<template>
  <div id="gVerify"></div>
</template>

<script>
import GVerify from "@/utils/gVerify.js";
export default {
  name: "gVerify",
  created() {
    this.loadAuthCode();
  },
  mounted() {
    //实例化插件
    this.gVerif = new GVerify({
      id: "gVerify",
      click: () => {
        this.loadAuthCode();
      }
    });
  },
  data() {
    return {
      gVerif: null,
      random: Math.random()
        .toString(36)
        .substr(2)
    };
  },
  methods: {
    loadAuthCode() {
      this.requestApi("login", "verificationCode", this.random, res => {
        this.gVerif.setCode(res.verificationCode).draw();
        this.$emit("emitAuthCode", res.verificationCode); //自定义事件名 传递的参数
      });
    }
  }
};
</script>

<style lang="less">
#gVerify {
  height: 40px;
}
</style>
